import { useEffect } from 'react';

import { useApolloClient } from '@apollo/react-hooks';
import { useNavigate } from 'react-router-dom';

import useAuth from 'hooks/auth/use-auth';
import { useServiceModeContext } from 'state/service-mode';
import { useStoreContext } from 'state/store';
import { routes } from 'utils/routing';

function SignOut() {
  const client = useApolloClient();
  const { signOut } = useAuth();
  const { resetStore } = useStoreContext();
  const { setServiceMode } = useServiceModeContext();
  const navigate = useNavigate();

  useEffect(() => {
    signOut().then(() => {
      resetStore();
      setServiceMode(null);
      navigate(routes.base);
      client.resetStore();
    });
  }, [client, navigate, resetStore, setServiceMode, signOut]);

  return null;
}

export default SignOut;
